"use client";

import { Program, SLPProgramType, StandardLP } from "@/services/types";
import { useInView } from "framer-motion";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import * as pixel from "../../utils/fpixel";
import dayjs from "dayjs";
interface Props {
  learnerData: Program | undefined;
  program?: StandardLP | undefined;
  programType?: SLPProgramType;
  isMobile?: boolean;
}
const HeroSection = (props: Props) => {
  const learnerData = props?.learnerData;
  const pathName = usePathname();
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  const sectionInView = useInView(sectionRef);
  const handleBtnClick = () => {
    if (!videoRef.current) return;
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };
  useEffect(() => {
    const videoElement = videoRef.current;
    const handleVideoEnd = () => {
      if (!videoElement) return;
      videoElement.pause();
      videoElement.currentTime = 0;
      setIsPlaying(false);
    };
    videoElement?.addEventListener("ended", handleVideoEnd);
    return () => {
      videoElement?.removeEventListener("ended", handleVideoEnd);
    };
  }, []);
  useEffect(() => {
    if (sectionInView) {
      document.querySelector(".section__fixed-card")?.classList.add("section__fixed-card--hide");
    } else {
      document.querySelector(".section__fixed-card")?.classList.remove("section__fixed-card--hide");
    }
  }, [sectionInView]);
  return <>
      <div className="section__container--small" ref={sectionRef}>
        <div className={`hero-section-wrap hero-${props.programType}`}>
          {props.programType !== SLPProgramType.WORKSHOP && <Image className="section__hero-banner-texture" src={"/images/new/GS-Texture.png"} alt="texture" loading="eager" fill />}
          <div className="hero-section-content">
            <div className="left-section">
              <div className="vid-wrap">
                <div>
                  <Image src={props.program?.attributes.banner_image.data?.attributes.url || ""} alt="mentor" width={506} height={284} className="main-img" loading="lazy" data-sentry-element="Image" data-sentry-source-file="HeroSection.tsx" />
                </div>
              </div>
              {props.isMobile && <div className="mentor-section">
                  <label className="mentor-text">Mentors</label>
                  <div className="mentor-wrap">
                    <div className="opaque-marquee">
                      {props.program?.attributes.premium_mentors.data
                  // ?.slice(0, 2)
                  .map((mentor, index) => <div key={index} className="identity">
                            <Image src={mentor.attributes.mentorImage.data?.attributes.url || ""} alt="mentor" height={40} width={40} loading="lazy" />
                            <div className="mentor">
                              <label className="name">
                                {mentor.attributes.name}
                              </label>
                              <label className="title">
                                {mentor.attributes.designation}
                                {mentor.attributes.companyName && `, ${mentor.attributes.companyName}`}
                              </label>
                            </div>
                          </div>)}
                    </div>
                    {props.program?.attributes.premium_mentors.data && props.program?.attributes.premium_mentors.data.length > 1 && <div className="plus-text">
                          <label>
                            +{" "}
                            {props.program?.attributes.premium_mentors.data.length - 1}{" "}
                            more
                          </label>
                        </div>}
                  </div>
                </div>}
              {!props.isMobile && <div className="button-container">
                  {learnerData?.apply_now_url ? <Link href={learnerData?.apply_now_url ?? "/"} className="mint-btn" onClick={() => {
                if (typeof window !== "undefined" && typeof window.gtag === "function") {
                  window.gtag("config", process.env.NEXT_PUBLIC_GA_ID, {
                    event_label: "Click event on Apply Now",
                    page_path: `${process.env.NEXT_PUBLIC_APP_URL}${pathName}`
                  });
                  pixel.event("ButtonClick", {
                    cta_text: "Apply Now"
                  });
                }
              }}>
                      Apply Now
                    </Link> : <Link href={learnerData?.buy_now_url ?? "/"} className="mint-btn btn-w-icon" onClick={() => {
                if (typeof window !== "undefined" && typeof window.gtag === "function") {
                  window.gtag("config", process.env.NEXT_PUBLIC_GA_ID, {
                    event_label: "Click event on Buy Now",
                    page_path: `${process.env.NEXT_PUBLIC_APP_URL}${pathName}`
                  });
                  pixel.event("ButtonClick", {
                    cta_text: "Buy Now"
                  });
                }
              }}>
                      {/* Buy Now */}
                      {props.programType === SLPProgramType.MENTORSHIP ? "Buy Now" : props.programType === SLPProgramType.SELFPACED ? "Unlock Instant Access" : "Register Now"}
                      {props.programType !== SLPProgramType.MENTORSHIP && <Image src="/images/course-diff/arrow-right.svg" alt="arrow" width={24} height={24} />}
                    </Link>}
                  {learnerData?.brochure_url && <a href={learnerData?.brochure_url ?? "/"} download target="_blank" rel="noopener noreferrer" className="btn-w-icon outline-btn" onClick={() => {
                if (typeof window !== "undefined" && typeof window.gtag === "function") {
                  window.gtag("config", process.env.NEXT_PUBLIC_GA_ID, {
                    event_label: "Click event on Brochure",
                    page_path: `${process.env.NEXT_PUBLIC_APP_URL}${pathName}`
                  });
                  pixel.event("ButtonClick", {
                    cta_text: "Brochure"
                  });
                }
              }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                        <path d="M8.5 12.125L12.5 16.125L16.5 12.125" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12.5 16.125V4.125" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" />
                        <path d="M19.5 17.125V17.725C19.5 19.055 18.43 20.125 17.1 20.125H7.9C6.57 20.125 5.5 19.055 5.5 17.725V17.125" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" />
                      </svg>
                      Brochure
                    </a>}

                  {props.programType !== SLPProgramType.MENTORSHIP && learnerData?.pricingProfile?.maxRetailPrice && <div className="pricing">
                        {learnerData?.pricingProfile?.discount > 0 && <div className="old-price">
                            <label>
                              ₹
                              {learnerData?.pricingProfile?.maxRetailPrice.toLocaleString("en-IN")}
                            </label>
                          </div>}
                        <div className="new-price">
                          <label>
                            ₹
                            {(learnerData?.pricingProfile?.maxRetailPrice - learnerData?.pricingProfile?.discount).toLocaleString("en-IN")}
                          </label>
                        </div>
                      </div>}
                </div>}
            </div>
            <div className="right-section">
              <div className="top-bar">
                <div className="main-title">
                  <label>{props.program?.attributes.name}</label>
                </div>
                <div className="para">
                  <p>{props.program?.attributes.sub_headline}</p>
                </div>
                <div className="date-time-section">
                  {props.programType !== SLPProgramType.SELFPACED && <div className="cohort-start-date">
                      <div className="cohort-start-date--title">
                        {/* Cohort start date */}
                        {props.programType === SLPProgramType.MENTORSHIP ? "Cohort start date" : "Date for Workshop"}
                      </div>
                      <div className="cohort-start-date--date">
                        {learnerData?.mappedCohort_StartDate && new Date(learnerData.mappedCohort_StartDate) < new Date() ? "Coming Soon" : dayjs(learnerData?.mappedCohort_StartDate || "").format("DD MMM YYYY")}
                      </div>
                    </div>}
                  {props.programType === SLPProgramType.WORKSHOP && <div className="cohort-start-date">
                      <div className="cohort-start-date--title">
                        {/* Cohort start time */}
                        {"Time for Workshop"}
                      </div>
                      <div className="cohort-start-date--date">
                        {dayjs(learnerData?.mappedCohort_StartDate).format("hh:mm A")}{" "}
                        IST
                      </div>
                    </div>}
                </div>
              </div>
              {!props.isMobile && <div className="mentor-section">
                  <label className="mentor-text">Mentors</label>
                  <div className="mentor-wrap">
                    <div className="opaque-marquee">
                      {props.program?.attributes.premium_mentors.data.map((mentor, index) => <div key={index} className="identity">
                            <Image src={mentor.attributes.mentorImage.data?.attributes.url || ""} alt="mentor" height={40} width={40} loading="lazy" />
                            <div className="mentor">
                              <label className="name">
                                {mentor.attributes.name}
                              </label>
                              <label className="title">
                                {mentor.attributes.designation}
                                {mentor.attributes.companyName && `, ${mentor.attributes.companyName}`}
                              </label>
                            </div>
                          </div>)}
                    </div>
                    {props.program?.attributes.premium_mentors.data && props.program?.attributes.premium_mentors.data.length > 2 && <div className="plus-text">
                          <label>
                            +{" "}
                            {props.program?.attributes.premium_mentors.data.length - 2}{" "}
                            more
                          </label>
                        </div>}
                  </div>
                </div>}
              {props.isMobile && <>
                  {props.programType !== SLPProgramType.MENTORSHIP && learnerData?.pricingProfile?.maxRetailPrice && <div className="pricing">
                        <div className="now-at-text">Now at</div>
                        <div className="new-price">
                          <label>
                            ₹
                            {(learnerData?.pricingProfile?.maxRetailPrice - learnerData?.pricingProfile?.discount).toLocaleString("en-IN")}
                          </label>
                        </div>
                        {learnerData?.pricingProfile?.discount > 0 && <div className="old-price">
                            <label>
                              ₹
                              {learnerData?.pricingProfile?.maxRetailPrice.toLocaleString("en-IN")}
                            </label>
                          </div>}
                      </div>}
                  <div className="button-container">
                    {learnerData?.apply_now_url ? <Link href={learnerData?.apply_now_url ?? "/"} className="mint-btn" onClick={() => {
                  if (typeof window !== "undefined" && typeof window.gtag === "function") {
                    window.gtag("config", process.env.NEXT_PUBLIC_GA_ID, {
                      event_label: "Click event on Apply Now",
                      page_path: `${process.env.NEXT_PUBLIC_APP_URL}${pathName}`
                    });
                    pixel.event("ButtonClick", {
                      cta_text: "Apply Now"
                    });
                  }
                }}>
                        Apply Now
                      </Link> : <Link href={learnerData?.buy_now_url ?? "/"} className="mint-btn btn-w-icon" onClick={() => {
                  if (typeof window !== "undefined" && typeof window.gtag === "function") {
                    window.gtag("config", process.env.NEXT_PUBLIC_GA_ID, {
                      event_label: "Click event on Buy Now",
                      page_path: `${process.env.NEXT_PUBLIC_APP_URL}${pathName}`
                    });
                    pixel.event("ButtonClick", {
                      cta_text: "Buy Now"
                    });
                  }
                }}>
                        {props.programType === SLPProgramType.MENTORSHIP ? "Buy Now" : props.programType === SLPProgramType.SELFPACED ? "Unlock Instant Access" : "Register Now"}
                        {props.programType !== SLPProgramType.MENTORSHIP && <Image src="/images/course-diff/arrow-right.svg" alt="arrow" width={24} height={24} />}
                      </Link>}
                    {learnerData?.brochure_url && <Link href={learnerData?.brochure_url ?? "/"} className="btn-w-icon outline-btn" onClick={() => {
                  if (typeof window !== "undefined" && typeof window.gtag === "function") {
                    window.gtag("config", process.env.NEXT_PUBLIC_GA_ID, {
                      event_label: "Click event on Brochure",
                      page_path: `${process.env.NEXT_PUBLIC_APP_URL}${pathName}`
                    });
                    pixel.event("ButtonClick", {
                      cta_text: "Brochure"
                    });
                  }
                }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                          <path d="M8.5 12.125L12.5 16.125L16.5 12.125" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M12.5 16.125V4.125" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" />
                          <path d="M19.5 17.125V17.725C19.5 19.055 18.43 20.125 17.1 20.125H7.9C6.57 20.125 5.5 19.055 5.5 17.725V17.125" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" />
                        </svg>
                        Brochure
                      </Link>}
                  </div>
                </>}
            </div>
          </div>
        </div>
      </div>
    </>;
};
export default HeroSection;